export default __webpack_public_path__ + "static/media/gallery_08.566fea7f.jpg";